import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

// Componentes
import { PublicComponent } from '../../app-public/public.component';
import { PubHeaderComponent } from '../../app-public/pub-header/pub-header.component';
import { PubFooterComponent } from '../../app-public/pub-footer/pub-footer.component';
import { PubHomeComponent } from '../../app-public/pub-home/pub-home.component';
import { PubSearcherComponent } from '../../app-public/pub-searcher/pub-searcher.component';
import { PubLoginComponent } from '../../app-public/pub-login/pub-login.component';

// Servicios
import { LoginService } from '../../services/login.service';
import { PubInvoicingServicesListComponent } from '../../app-public/pub-invoicing-services-list/pub-invoicing-services-list.component';
import { PubMenuComponent } from '../../app-public/pub-menu/pub-menu.component';
import { PersonService } from '../../services/person.service';
import { InvoicingServiceDataService } from '../../services/invoicing-service-data.service';
import { ApplicationService } from '../../services/application.service';
import { PubInvoicingServicesDetailComponent } from '../../app-public/pub-invoicing-services-detail/pub-invoicing-services-detail.component';
import { PubAccessibilityComponent } from '../../app-public/pub-accessibility/pub-accessibility.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    TranslateModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forRoot([
      {
        path: 'portal/accesibilidad',
        component: PubAccessibilityComponent,
        pathMatch: 'full'
      },
      { path: '', redirectTo: 'portal', pathMatch: 'full' },
      {
        path: 'portal',
        component: PublicComponent,
        children: [
          {
            path: '',
            component: PubHomeComponent,
            pathMatch: 'full'
          },
          {
            path: 'empresa-servicios-de-facturacion',
            component: PubInvoicingServicesListComponent,
            pathMatch: 'full'
          },
          {
            path: 'sello-empresa-servicios-de-facturacion/:identifier',
            component: PubInvoicingServicesDetailComponent,
            pathMatch: 'full'
          }
        ]
      }
    ])
  ],
  providers: [
    LoginService,
    PersonService,
    InvoicingServiceDataService,
    ApplicationService
  ],
  declarations: [
    PublicComponent,
    PubHeaderComponent,
    PubFooterComponent,
    PubHomeComponent,
    PubSearcherComponent,
    PubLoginComponent,
    PubInvoicingServicesListComponent,
    PubInvoicingServicesDetailComponent,
    PubMenuComponent,
    PubAccessibilityComponent
  ]
})
export class PublicModule { }



// WEBPACK FOOTER //
// ./src/app/modules/public/public.module.ts